module.exports = new __parcel__URL__("logo.38564239.svg").toString();